import React, { useState } from 'react';
import { CircularProgress, Modal } from '@material-ui/core';
import emailjs from 'emailjs-com';

import css from './ContactForm.module.css';

const ContactForm = () => {

    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [error, setError] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();

        setLoading(true);

        emailjs.sendForm('service_f647kqv', 'template_f1l3w8k', e.target, 'user_4ec3ZwDDMFlLvnGoxsOD2')
            .then((result) => {
                setLoading(false);
                setError(false);
                setShowModal(true);
            }, (error) => {
                setLoading(false);
                setError(true);
                setShowModal(true);
            });
    }

    const closeModal = () => {
        setShowModal(false);
        document.getElementById('name').value = '';
        document.getElementById('email').value = '';
        document.getElementById('message').value = '';
    }

    return (
        <form className={css.Form} onSubmit={sendEmail}>
            <label>Ime*</label><br />
            <input id="name" type="text" name="user_name" required /><br /><br />
            <label>Email*</label><br />
            <input id="email" type="email" name="user_email" required /><br /><br />
            <label>Poruka*</label><br />
            <textarea id="message" name="message" required></textarea><br /><br />
            <input type="submit" value="POŠALJI" />
            {loading ? <div className={css.CircularProgress}><CircularProgress size={18} /></div> : null}
            <Modal open={showModal}
                onClose={closeModal}>
                <div className={css.Modal}>
                    {error ? <p>Dogodila se greška!<br />Pokušajte ponovo kasnije.</p> : <p>Poruka je poslana!</p>}
                    <button onClick={closeModal}>OK</button>
                </div>
            </Modal>
        </form>
    );
};

export default ContactForm;